import {
  GetStaticPaths,
  InferGetStaticPropsType,
  GetStaticPropsContext
} from 'next'

/* blocks */
import Layout from '@/cmp/templates/Layout/Layout'
import ContentTypes from '@/cmp/templates/ContentTypes/ContentTypes'

/* utils */
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import { newServiceCategoryQuery } from '@/utils/queries/service_category'
import { constructBreadcrumbJsonSchema } from '@/utils/functions/jsonSchema'
import { capture404PageError } from '@/utils/functions/elk-server'
import {
  INSTANT_REVALIDATION,
  TEN_MINS_REVALIDATION
} from '@/utils/constants/revalidation'
import { constructMetadataFromStrapiData } from '@/utils/functions/strapi'

const IndividualServiceCategory = ({
  data
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const breadcrumbs = [
    { name: 'Pepper Content', url: '/' },
    {
      name: data.seo.title,
      url: `/${data.slug}/`
    }
  ]

  return (
    <Layout
      title={data.seo.title}
      meta={constructMetadataFromStrapiData(data.seo)}
      canonical={`/${data.slug}/`}
      jsonSchema={[constructBreadcrumbJsonSchema(breadcrumbs)]}
    >
      <ContentTypes data={data} />
    </Layout>
  )
}

export const getStaticProps = async (context: GetStaticPropsContext) => {
  const { params } = context
  const slug = params?.slug as string

  const result = await getStrapiGraphqlData<NewCategoryPageQuery>(
    newServiceCategoryQuery.loc?.source.body,
    { slug }
  )
  const page = result?.currentPage?.data[0]

  if (!page) {
    capture404PageError(`/${slug}/`)
    return { notFound: true, revalidate: INSTANT_REVALIDATION }
  }

  return {
    props: {
      data: page.attributes
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export default IndividualServiceCategory
